<template>
  <div class="template-table">
    <block-title class="block-title" title="自定义模板表格">
      <div class="form-content">
        <div class="content-upload">
          <a-upload
            :show-upload-list="false"
            :before-upload="beforeUpload"
            @change="handleFileChange"
          >
            <a-button class="uploadBtn" type="primary">
              <img src="@/assets/img/icon_upload.png" alt="">
              {{selectFileBtnTxt}}
              </a-button>
          </a-upload>
        </div>
        <p class="upload-tip">单次上传最大不超过10000条数据，文件大小最大不超过10M，文件格式支持xlsx</p>
        <p v-if="form.fileUrl" class="filename">
          <img class="filenameLeft" src="@/assets/img/icon_file.png" alt="">
          {{form.fileName}}
        </p>
      </div>
    </block-title>
  </div>
</template>

<script>
import BlockTitle from '@/components/panel/BlockTitle.vue'
import { getFileNameSuffix } from "@/utils/handleFile.js";
import { uploadTemplate } from '../../api';

export default {
  name: 'TemplateTable',
  components: {
    BlockTitle
  },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
      default: 0,
    },
    headRow: {
      type: String || Number,
      default: '1',
    },
  },
  data() {
    return {
      // 文件最大10M
      fileMaxSize: 1024 * 1024 * 10,
      // 文件类型暂时只支持 .xlsx
      fileTypeLimit: [".xlsx"],
      file: undefined,
    }
  },
  computed: {
    selectFileBtnTxt() {
      return !this.form.fileName ? "选择文件" : "重新选择";
    },
  },
  methods: {
    changeFile() {
      this.handleFileChange(this.file)
    },
    getValidate() {},
    // 上传文件前
    beforeUpload(file) {
      const { fileMaxSize, fileTypeLimit } = this;
      const fileSize = file.size;
      const fileType = getFileNameSuffix(file.name);
      if (!fileTypeLimit.includes(fileType)) {
        this.$message.error("文件格式仅支持xlsx");
      }else if (fileSize > fileMaxSize) {
        this.$message.error("文件最大不超过10M");
      }
      return false
    },
    async handleFileChange(info) {
      this.file = info
      const { file } = info
      const formData = new FormData();
      formData.append("file", file);
      formData.append("headRow", this.headRow);
      const res = await uploadTemplate(formData)
      const fileParams = {
        fileName: file.name,
        fileUrl: res.filePath
      }
      this.$emit('change', true, this.index)
      this.$emit('changeList', res.headFields, fileParams)
    },
  }
}
</script>

<style lang="less" scoped>
.template-table {
  .uploadBtn {
    padding: 0 36px;
    img {
      width: 20px;
      height: 20px;
      margin-right: 12px;
    }
  }
  .upload-tip {
    margin-top: 16px;
    color: #A9ABAE;
  }
  .filename {
    width: 536px;
    height: 64px;
    margin-top: 32px;
    border-radius: 4px;
    border: 1px solid #E7E9EC;
    font-size: 14px;
    color: #171717;
    line-height: 64px;
    padding: 0 20px 0 24px;
    .filenameLeft{
      margin-right: 24px;
      width: 28px;
      height: 28px;
    }
    .filenameRight{
      float: right;
      margin-top: 23px;
      &:hover{
        cursor: pointer;
      }
    }
  }
}
</style>